module.exports = __webpack_public_path__ + "img/selected1-min.6a2907bc.png";